[
  {
    "label": "Moka Pot",
    "ratio": {
      "coffee": 1,
      "water": 9
    },
    "factor": 10
  },
  {
    "label": "PuckPuck",
    "ratio": {
      "coffee": 19,
      "water": 250
    },
    "factor": 2,
    "iceRatio": 20
  },
  {
    "label": "Cold Brew",
    "ratio": {
      "coffee": 3,
      "water": 40
    },
    "factor": 30
  },
  {
    "label": "French Press",
    "ratio": {
      "coffee": 1,
      "water": 14
    },
    "factor": 25
  },
  {
    "label": "Aeropress",
    "ratio": {
      "coffee": 7,
      "water": 100
    },
    "factor": 2
  },
  {
    "label": "Iced Aeropress",
    "ratio": {
      "coffee": 7,
      "water": 100
    },
    "factor": 2,
    "iceRatio": 30
  },
  {
    "label": "V60",
    "ratio": {
      "coffee": 1,
      "water": 15
    },
    "factor": 16
  },
  {
    "label": "Orea",
    "ratio": {
      "coffee": 3,
      "water": 50
    },
    "factor": 5
  },
  {
    "label": "Chemex",
    "ratio": {
      "coffee": 1,
      "water": 17
    },
    "factor": 30
  }
]
